// extracted by mini-css-extract-plugin
module.exports = {"List":"CustomerList_List__1mucU","Odd":"CustomerList_Odd__2d10D","Even":"CustomerList_Even__3e9Rd","Reset":"CustomerList_Reset__1FbEy"};